<template>
  <div>
    <div class="photo-album">
      <div class="album-img" ref="listContainer" @scroll="handleScroll" v-show="!albumtab">
        <template v-for="item in photo_album">
        <div  class="list-container" v-if="item.img.length>0" :key="item.key">
          <div 
            :id="`index-${item.key}`" 
            class="group-title"
          >
          {{ item.name }}
          </div>
          <div  class="group-items">
            <div v-for="(img,index) in item.img" :key="index">
              <img v-lazy="ImgPreUrl+img" height="14px" class="meeting-img gallery-img"  @click="carouse(img)"/>
            </div>
          </div>
        </div>
        </template>
      </div>
      <div class="album-back" @click="albumtab=false" v-if="albumtab">
        <span>回到相册 <i class="el-icon-back"></i></span>
      </div>
      <div class="album-img" v-if="albumtab">
         <el-carousel :autoplay="false"  arrow="always" height="670px" :loop="false" :initial-index="indexist" @change="albumTo"  id="carousel"  :key="indexist">
          <el-carousel-item v-for="(item,index) in mergeImgList()" :key="index">
            <div class="carousel-item">
                <div class="gallery-img">
                  <img :src="ImgPreUrl+item" height="150%" width="150%"/>
                  <div class="gallery-mask"></div>
                </div>
                <div class="carousel-img">
                  <img :src="ImgPreUrl+item"/>
                </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="album-img-title" ref="contentItem">
          <div class="title" v-for="(item,index) in mergeImgList()" :key="index" :class="{'album-tab':indexist===index}" :id="`album-${index}`" @click="albumTo(index)">
            <img v-lazy="ImgPreUrl+item"/>
          </div>
        </div>
      </div>
      <!--相册导航-->
      <div class="album-name" v-if="!albumtab">
        <template v-for="(item,index) in photo_album">
          <div  :key="index" class="album-item" :class="{'active':currentKey===item.key}" v-if="item.img.length>0" @click="scrollTo(item.key)">
              <i :class="['iconfont icon-check',item.icon]"></i>
              <p>{{item.name}}</p>
              <span>({{item.img.length}})</span>
          </div>
        </template>
      </div>
      <div class="album-name" v-else>
          <div class="rooms-feature">
               酒店设施
          </div>
          <div class="star-name"> 
            <div v-for="(item,index) in info.facility.split(',')" :key="index" >
                <i class="el-icon-circle-check"></i>
                {{ item | formatVar('FacilitiesBasiciconclass')}}
            </div>
          </div>
        <!-- <div class="Introduction-btn" @click="$emit('bookHotel')">
            去询价
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Carousels from "./Comps/Carousels.vue";
export default {
  name: 'photoAlbum',
  components: {Carousels},
  props: {
    photo_album:{
      type: Array,
      default: () => []
    },
    info:{
      type: Object,
      default: () => {}
    },
    // 滚动动画持续时间(毫秒)
    duration: {
      type: Number,
      default: 300
    },
    // 缓动函数类型
    easing: {
      type: String,
      default: 'easeOutQuad',
      validator: (value) => {
        return ['linear', 'easeOutQuad', 'easeInOutQuad'].includes(value);
      }
    }
  },
  data() {
    return {
        indexKeys: [], // 索引列表
        currentKey: '', // 当前激活的索引
        currentTouchKey: '', // 当前触摸的索引
        groupPositions: {}, // 记录每个分组的位置信息
        isScrolling: false, // 是否正在执行滚动动画
        indexist:10,        //当前索引
        photoPositions:{}, // 记录每个相册的位置信息
        albumtab:false, //相册导航是否显示

    };
  },
  computed: {},
  watch: {
      photo_album:{
        handler(newVal, oldVal) {
          this.currentKey = this.photo_album.length > 0? this.photo_album[0].key : '';
          this.initIndex();
          this.$nextTick(() => {
            this.calculatePositions();
          });
        },
       // 关键配置：初始化时立即执行一次
      immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    childMethod(){
      this.albumtab=false;
    },
    // 初始化索引列表
    initIndex() {
      this.indexKeys = this.photo_album.map(group => group.key);
    },
    // 计算每个分组的位置信息
    calculatePositions() {
      this.groupPositions = {};
      this.photo_album.forEach(group => {
        const element = document.getElementById(`index-${group.key}`);
        if (element) {
          this.groupPositions[group.key] = element.offsetTop;
        }
      });
    },
    // 平滑滚动到指定索引位置
    scrollTo(key) {
      const targetPosition = this.groupPositions[key];
      if (targetPosition === undefined || this.isScrolling) return;
      this.isScrolling = true;
      this.currentKey = key;
      
      const startPosition = this.$refs.listContainer.scrollTop;
      const distance = targetPosition - startPosition;
      const startTime = performance.now();

      // 执行滚动动画
      const animateScroll = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        
        // 如果动画未完成
        if (elapsedTime < this.duration) {
          // 根据选择的缓动函数计算当前位置
          let progress;
          switch (this.easing) {
            case 'linear':
              progress = elapsedTime / this.duration;
              break;
            case 'easeOutQuad':
              progress = 1 - (1 - elapsedTime / this.duration) * (1 - elapsedTime / this.duration);
              break;
            case 'easeInOutQuad':
              progress = elapsedTime / (this.duration / 2) < 1 
                ? 0.5 * Math.pow(elapsedTime / (this.duration / 2), 2)
                : 1 - 0.5 * Math.pow(2 - elapsedTime / (this.duration / 2), 2);
              break;
            default:
              progress = elapsedTime / this.duration;
          }
          console.log(animateScroll);
          this.$refs.listContainer.scrollTop = startPosition + distance * progress;
          requestAnimationFrame(animateScroll);
        } else {
          // 动画完成，确保精确到达目标位置
          this.$refs.listContainer.scrollTop = targetPosition;
          this.isScrolling = false;
        }
      }
      // 开始动画
      requestAnimationFrame(animateScroll);
    },
    // 处理列表滚动，更新当前激活的索引
    handleScroll() {
      // 动画执行中或触摸时不更新
      if (this.isScrolling) return;
      const scrollTop = this.$refs.listContainer.scrollTop;
      const keys = [...this.indexKeys].reverse(); // 倒序检查
      for (const key of keys) {
        const position = this.groupPositions[key];
        if (scrollTop >= position - 10) { // 留出一点误差空间
          this.currentKey = key;
          break;
        }
      }
    },
    /**banner相册点击事件 */
    carouse(item){
      let imgList = [];
      this.photo_album.forEach(group => {
        imgList = imgList.concat(group.img);
      });
      this.albumtab=true;
      this.indexist=imgList.indexOf(item);
    },
    //整合图片列表
    mergeImgList(){
      let imgList = [];
      this.photo_album.forEach(group => {
        imgList = imgList.concat(group.img);
      });
      return imgList;
    },
    // 相册导航点击事件
    albumTo(index){
      this.indexist=index;
      let room = document.getElementById(`album-${index}`);
      room.scrollIntoView({
        behavior: 'smooth', // 滚动动画：smooth（平滑）/ auto（瞬间）
        block: 'nearest',    // 垂直对齐方式：start（顶部对齐）/ center（居中）/ end（底部对齐）
        inline: 'center'  // 水平对齐方式（默认无需修改）
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.photo-album-title{
  text-align: left;
}
.photo-album{
    width: 100%;
    display: flex;
    border-top: 1px #eee solid;
    padding-top: 10px;
}
.album-img{
    width: 86%;
    padding: 0 1%;
    height: 800px;
    overflow: auto;
}
.album-name{
    width: 10%;
}
.album-item{
  display: flex;
  background-color: #f5f5f5;
  height: 40px;
  line-height: 40px;
  text-align: left;
  border-radius: 4px;
  width: 130px;
  justify-content: left;
  margin-left: 20px;
  margin-bottom: 12px;
  cursor: pointer;
  i{
    margin-left: 16px;
    margin-right: 6px;
  }
}
.group-title {
  font-size: 18px;
  color: #666;
  padding: 10px 0;
  font-weight: bold;
  text-align: left;
}
.group-items{
  width: 100%;
  display: flex;
  flex-wrap:wrap;
  div{
    width: calc(33% - 12px);
    margin-bottom: 12px;
    margin-right: 12px;
    height: 400px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.active{
  background-color: var(--smtc-color-primary);
  color: #fff;
}
.meeting-img{
  cursor: pointer;
}
.carousel-item{
  width: 100%;
  height: 630px;
  background-color: #000;
  position: relative;
}
.gallery-img{
  position: relative;
}
.gallery-mask{
  width: 100%;
  height: 100%;
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, .5);
  left: 0;
  position: absolute;
  top: 0;
}
.gallery-img img{
  margin-top: -25%;
  margin-left: -25%;
}
.carousel-img{
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    width: 100%;
    z-index: 9;
    top: 0;
    top: 0;
    img{
      border-radius: 8px;
      height: 100%;
      -o-object-fit: contain;
      object-fit: contain;
      width: 100%;
      max-width: 100%;
    }
}
.album-img-title{
  white-space: nowrap;
  justify-content: center;
  height: 120px;
  width: 100%;
  position: relative;
  overflow-x: auto;
  margin-top: 10px;
  img{
    width: 100%;
    height: 100%;
  }
  .title{
    width: 80px;
    height: 80px;
    display: inline-block;
    border-radius: 6px;
    margin-right: 6px;
    overflow: hidden;
    cursor: pointer;
  }
  // .title{
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  //   img{
  //     width: 100%;
  //     height: 100%;
  //     max-width: 100%;
  //     max-height: 100%;
  //     border-radius: 8px;
  //   }
  // }
}
.album-img-title::-webkit-scrollbar {
  display: none; /* 完全隐藏滚动条 */
}
.album-img-title .album-tab{
  img{
    border: 2px solid var(--smtc-color-primary);
    height: 76px;
    width: 76px;
  }
  
}
.album-back{
  width: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #eee;
  border-radius: 0 10px 10px 0;
  margin-top: -10px;
  cursor: pointer;
}
.album-back span{
  width: 20px;
  margin: 0 auto;
}
.Introduction-btn{
  width: 100px;
  height: 60px;
  line-height: 60px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  background-color: var(--smtc-color-primary);
  color: #fff;
  cursor: pointer;
  position: absolute;
  bottom: 36px;
  right: 20px;
}
.star-name{
    display: flex;
    flex-wrap: wrap;
    >div{
        width: 50%;
        text-align: left;
        margin-top: 16px;
        display: flex; 
        i{
            font-size: 16px;
            margin-top: 3px;
            margin-right: 6px;
        }
    }
}
.rooms-feature{
    display: flex;
    font-weight: bold;
    font-size: 16px;
    color: #333;
    text-align: left;
    margin-top: 16px;
}
</style>
<style>
  .album-img .el-carousel__indicators--horizontal{
    display: none;
  }
  .album-img .el-carousel__arrow{
    background-color: #fff;
    color: var(--smtc-color-primary); 
  }
</style>